import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Duplicate template</Typography>
      <p>Sometime you may prefer to make a copy of an existing template rather than create a new one from 
        a Smartix base template. This is where you can do that. Just choose a new name and hit the button.
      </p>
    </div>
  )
}

export default HelpText